module.exports = [{
  name: "Triggerman",
  loadout: [1],
  secondary: true,
  colors: [10975328, 4013373, 2302755, 2631720, 7098434, 12566463],
  health: 100,
  segs: 6,
  speed: 1.05
}, {
  name: "Hunter",
  loadout: [0],
  secondary: true,
  colors: [10975328, 8083261, 6506290, 2631720, 6506290, 4008733],
  health: 60,
  segs: 5,
  speed: 1.05
}, {
  name: "Run N Gun",
  loadout: [3],
  colors: [10975328, 4088706, 3099491, 2631720, 6506290, 1715002],
  health: 100,
  segs: 6,
  speed: 1.18
}, {
  name: "Spray N Pray",
  loadout: [6],
  txts: ["Calling in the Big Guns?", "Remember - No russian.", "Pesky Snipers..."],
  colors: [10975328, 5793865, 4806204, 2631720, 2631720, 3160103],
  health: 170,
  segs: 7,
  regen: 0.05,
  speed: 1
}, {
  name: "Vince",
  loadout: [5],
  secondary: true,
  colors: [8412234, 5526119, 4144461, 2631720, 2631720, 2697267],
  health: 100,
  segs: 6,
  speed: 1
}, {
  name: "Detective",
  loadout: [4],
  colors: [10975328, 7360054, 4410462, 2631720, 6506290, 4140062],
  health: 100,
  segs: 6,
  speed: 1
}, {
  name: "Marksman",
  loadout: [7],
  secondary: true,
  colors: [10975328, 5793865, 4806204, 2631720, 2631720, 2699298],
  health: 90,
  segs: 6,
  speed: 1
}, {
  name: "Rocketeer",
  loadout: [8],
  secondary: true,
  txts: ["..."],
  colors: [10975328, 5793865, 4806204, 2631720, 7098434, 2831140],
  health: 130,
  segs: 7,
  speed: 0.86
}, {
  name: "Agent",
  loadout: [9],
  colors: [10975328, 4013373, 2302755, 2631720, 2631720, 12566463],
  health: 100,
  segs: 6,
  speed: 1.2
}, {
  name: "Runner",
  txts: ["You sure about this?", "...", "Oh boy", "I don't know about this...", "Not me again..."],
  loadout: [12],
  colors: [10975328, 4013373, 2302755, 2631720, 2631720, 2302755],
  health: 100,
  segs: 6,
  regen: 0.2,
  speed: 1
}, {
  name: "Deagler",
  hide: true,
  loadout: [10],
  colors: [10975328, 4013373, 2302755, 2631720, 2631720, 2302755],
  health: 60,
  segs: 5,
  speed: 1
}, {
  name: "Bowman",
  loadout: [13],
  secondary: true,
  colors: [10975328, 9530450, 6308654, 2631720, 2631720, 4666663],
  health: 100,
  segs: 6,
  speed: 1
}, {
  name: "Commando",
  loadout: [14],
  secondary: true,
  colors: [10975328, 4013373, 2302755, 2631720, 10050604, 1513239],
  health: 100,
  segs: 6,
  speed: 1
}];